import React from 'react';
import { Card, CardBody } from 'reactstrap';

const UserGroupIconCard = ({ icon, alt, text }) => {
    return (
        <div className="d-flex flex-column align-items-center">
            <Card
                style={{
                    width: '65px',
                    height: '65px',
                    borderRadius: '12px',
                    border: '1px solid #e0e0e0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: 'rgb(0 0 0 / 11%) 5px 5px 5px',
                }}
            >
                <CardBody className="p-0 d-flex align-items-center justify-content-center">
                    <img
                        src={icon}
                        alt={alt}
                        style={{ width: '32px', height: '32px' }}
                    />
                </CardBody>
            </Card>
            <div style={{
                marginTop: '-18px',
                color: '#6c757d',
                fontSize: '14px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textAlign: 'center',
                textOverflow: 'ellipsis',
                maxWidth: '100%', // optional, based on layout
            }}>
                {text}
            </div>
        </div>
    )
}

export default UserGroupIconCard;